module.exports = __webpack_public_path__ + "static/img/2.1f6db99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/2.png
// module id = m8F8
// module chunks = 0